import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { hideNotificationDialog } from "redux/actions/notificationActions";
import { useDispatch, useSelector } from "react-redux";
import { Button, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function AlertDialog(props) {
  const dispatch = useDispatch();

  const { isShowing, title, content, button } = useSelector(
    (state) => state.notification
  );

  const handleClose = (event, reason) => {
    event.preventDefault();
    dispatch(hideNotificationDialog());
  };

  return (
    <div>
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={isShowing}
        onClose={handleClose}
        aria-labelledby="title"
        aria-describedby="description"
      >
        <DialogTitle id="title">
          {title}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="description">{content.errorMessage? content.errorMessage : content}</DialogContentText>
        </DialogContent>

        <DialogActions sx={{ pl: 3, pb: 3, justifyContent: "flex-start" }}>
          <Button variant="contained" color="primary" onClick={handleClose}>
            {button}
          </Button>
        </DialogActions>

      </Dialog>
    </div>
  );
}
